import auth from '~/routes/auth';
import account from '~/routes/account';
import tos from '~/routes/tos';

export default () => [...auth, ...account, ...tos];
